import React from 'react';

const IconBtnGo = props =>
  <svg viewBox="0 0 22 22" {...props}>
    <path d="M18.505 11l-7.406-3.999v3.196H3.495v1.604h7.604v3.196L18.505 11z" />
  </svg>;

export default IconBtnGo;
